<template>
  <div>
    <div v-if="showAnimation" style="height: 300px;">
      <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
    </div>
    <div v-else>
      <br/>
      <v-data-table
        id="data-table-monthly-data"
        class="primary darken-1 white--text"
        :headers="headers"
        :items="items"
        hide-default-footer
        dense
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.date`]="{ item }">
          <v-timeline class="timeline-table" dense>
            <v-timeline-item color="primary lighten-1" small fill-dot> {{ item.date }}</v-timeline-item>
          </v-timeline>
        </template>
        <template v-slot:[`item.value`]="{ item }">
          <span> {{ showNormalValue(item.value) }}</span>
        </template>

      </v-data-table>
      <div class="mt-3" style="display: flex; align-items: center;justify-content: space-between;font-style: normal;font-weight: normal;font-size: 12px;line-height: 16px;">
        <div>Mostrando {{startItem}}-{{endItem}} de {{items.length}} resultados</div>
        <div style="display: flex; align-items: center;">
          <span class="mr-3">Linhas por página:</span>
          <div style="max-width: 64px;">
            <v-select
              v-model="itemsPerPage"
              :items="itemsPerPageOptions"
              dense
              hide-details
              item-color="secondary lighten-1"
              color="secondary lighten-1"
            ></v-select>
          </div>
          <v-pagination
            class="ml-3 pagination-data elevation-0"
            color="secondary lighten-1"
            v-model="page"
            :length="pageCount"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingAnimation from "../LoadingAnimation";
import moment from "moment";
import html2canvas from "html2canvas";
import {jsPDF} from "jspdf";
import writeXlsxFile from "write-excel-file";
export default {
  components: {LoadingAnimation},
  props: ['searchResult'],
  name: "RainEstimationHistoricalDataTableDailyMonthly",
  data(){
    return {
      headers: [],
      items: [],
      showDateWithEmptyData: true,
      itemsPerPage: undefined,
      itemsPerPageOptions: [],
      page: 1,
      pageCount: undefined,
      rawItems: [],
      sensorColumnKeys: [],
      exportFileName: "export",
      showAnimation: false,
      loading: false,
    }
  },
  watch:{
    itemsPerPage(value){
      if(value){
        this.page = 1;
      }
    },
    searchResult(value){
      if(value){
        this.initialize();
      }
    }
  },
  mounted(){ this.initialize() },
  methods:{
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    generateHeaders(type){
      const headers = []
      const dateHeader = {
        text: type === "diario" ? "Dia" : type === "mensal" ? "Mês" : "",
        align: 'start',
        sortable: true,
        value: 'date',
        width: 300,
      };
      headers.push(dateHeader);
      headers.push({
        text: 'Precipitação (mm)',
        align: 'center',
        sortable: true,
        value: 'value',
        width: 300,
      });
      headers.push({
        text: 'vazão (m³/s)',
        align: 'end',
        sortable: true,
        value: 'flow',
        width: 300,
      });
      return headers;
    },
    generateMonthlyItems(resultList, flowForecasts){
      let result;
      result = resultList.map((result) => ({
        date: this.capitalize(moment(`${result.year}-${result.month}`, "YYYY-MM").locale("pt-br").format("MMMM/YYYY")),
        dateIso: `${result.year}-${result.month}`,
        value: result.value.prec,
        flow: 0,
      }));
      const flowReversed = flowForecasts.reverse();
      for(const item in flowReversed){
        result[item].flow = flowReversed[item].value.flow.toFixed(3);
      }
      return result;
    },
    capitalize(text){
      return text[0].toUpperCase() + text.slice(1);
    },
    generateDailyItems(resultList, flowForecasts){
      let result;
      result = resultList.map((result) => ({
        date: moment(result.date, "YYYY-MM-DD").format("DD/MM/YYYY"),
        dateIso: result.date,
        value: result.value.precIntensity,
        flow: 0,
      }));
      for(const item in result){
        if (flowForecasts && flowForecasts[item] && result[item]) {
          if(flowForecasts[item].date === result[item].dateIso){
            result[item].flow = flowForecasts[item].value.flow.toFixed(3);
          }
        }
      }
      return result;
    },
    showNormalValue(value){
      return value || value === 0 ? Number(value).toFixed(1) :  "--";
    },
    generatePDF() {
      this.itemsPerPage = 100;
      setTimeout(()=>{
        const tableElement = document.getElementById('data-table-monthly-data');
        html2canvas(tableElement).then(canvas => {
          var imgData = canvas.toDataURL('image/png');
          var imgWidth = 210;
          var pageHeight = 295;
          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight;
          var doc = new jsPDF('p', 'mm');
          var position = 0;
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          doc.save(`${this.exportFileName}.pdf`);
        });
        this.itemsPerPage = this.itemsPerPageOptions[0];
      }, 1000);
    },
    generateCSV(){
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(this.items[0]).join(";"),
        ...this.items.map(item => Object.values(item).join(";"))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", `${this.exportFileName}.csv`);
      link.click();
    },
    async generateXLS(){
      const mapItems = this.mapItemsToExport(this.items);
      const columns = ["date", "Precipitação (mm)"]
      const schema = columns.map((column) => ({ column, type: String, fontStyle: "normal", value: item => item[column] }));
      await writeXlsxFile(mapItems, {
        schema,
        fileName: `${this.exportFileName}.xlsx`,
        headerStyle: {
          fontWeight: 'normal',
          align: 'center'
        },
      });
    },
    mapItemsToExport(items){
      let holder = []
      const name = 'Precipitação (mm)'
      for(let item in items){
        let groupItem = { date: items[item].date };
        groupItem[name] = items[item].value.toString()
        holder.push(groupItem)
      }
      return [...holder]
    },
    generateExportFileName(searchResult){
      const typeName = searchResult.type === "mensal" ? "Dados_históricos_da_estimativa_de_chuva_mensal" : "Dados_históricos_da_estimativa_de_chuva_diario";
      const stationName = searchResult.location.text;
      const periodFormat = `${this.formatDate(searchResult.date_start, searchResult.type)} até ${this.formatDate(searchResult.date_end, searchResult.type)}`
      return `${stationName}-${typeName}-${periodFormat}`;
    },
    formatDate(date, type){
      const stringFormat = type === "mensal" ? "MMMM/YYYY" : type === "diario" ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm";
      const dateFormatted = moment(date).tz("America/Sao_Paulo").locale("pt-br").format(stringFormat);
      return type === "mensal" ? this.capitalize(dateFormatted) : dateFormatted;
    },
    initialize(){
      this.loading = true
      this.showAnimation = true
      const { type, resultList, flowForecasts } = this.searchResult;
      this.headers = this.generateHeaders(type);
      let generatedItems = [];
      if(type === "mensal") generatedItems = this.generateMonthlyItems(resultList , flowForecasts);
      if(type === "diario") generatedItems = this.generateDailyItems(resultList, flowForecasts);
      this.rawItems = [...generatedItems]
      this.items = Object.assign([], this.rawItems);
      this.itemsPerPageOptions = type === "mensal" ? [ 12, 25, 50, 100] : [ 10, 25, 50, 100];
      this.itemsPerPage = this.itemsPerPageOptions[0];
      this.exportFileName = this.generateExportFileName(this.searchResult);
      this.loading = false
    },
  },
  computed:{
    startItem(){ return (this.page - 1) * this.itemsPerPage + 1 },
    endItem(){ return this.page * this.itemsPerPage },
  },
}
</script>

<style scoped>
#data-table-monthly-data ::v-deep th{
  border-bottom: 1px solid #D9D9D9 !important;
  padding: 0px 20px !important;
  color: #FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}

#data-table-monthly-data ::v-deep td{
  border-bottom: 1px solid #2D324F !important;
  padding: 0px 20px !important;
  font-style: normal;
  font-weight: 500;
  font-size: 14px !important;
  line-height: 18px;
}

#data-table-monthly-data ::v-deep tr:hover{
  background: var(--v-primary-darken2);
}

#data-table-monthly-data ::v-deep .v-data-table__wrapper{
  border-bottom: 1px solid #2D324F !important;
}

.timeline-table::before{
  background: #2D324F !important;
}

.pagination-data ::v-deep .v-pagination__navigation{
  background: var(--v-primary-darken1) !important;
  border-width: 2px;
  border-style: solid;
  border-color: white;
}

.pagination-data ::v-deep .v-pagination__item.v-pagination__item--active{
  background: var(--v-secondary-lighten1) !important;
  border-width: 2px;
  border-style: solid;
  border-color: white;
  color: var(--v-primary-darken1) !important;
}

.pagination-data ::v-deep .v-pagination__item{
  background: var(--v-primary-darken1) !important;
  border-width: 2px;
  border-style: solid;
  border-color: white;
}
</style>
